"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDiagnostics = void 0;
const sonar_http_1 = require("@sonar-software/sonar-http");
exports.getDiagnostics = (0, sonar_http_1.createGetEndpoint)(`/api/v3/diagnostics?url=${encodeURI(window.location.href)}`);
//# sourceMappingURL=getDiagnostics.js.map